<template>
    <div>
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center align-self-center pb-2">
                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                            <li class="text-white"><a href="#">Home</a></li>
                            <li class="text-white"><a href="#">Portfolio</a></li>
                            <li class="text-white active">2 Column</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Breadcrumb End -->
        <!-- portfolio Grid-col-2 Start -->
        <section class="section portfolio-section grid-col-2">
            <div class="container">
                <div class="row">
                    <div class="col wow fadeInUp" data-wow-duration="1.5s">
                        <div class="mb-3">
                            <h1 class="section-h1 font-weight-bold">
                                Gallery 2 Columns
                            </h1>
                            <p class="text-left">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                            </p>
                            <hr class="hr-border">
                        </div>
                    </div>
                </div>
                <div class="filters text-center wow fadeInUp" data-wow-duration="1.5s">
                    <ul class="p-0 list-unstyled d-flex align-items-center justify-content-center portfolio-filter">
                        <li class="active py-3 mx-3" data-filter="*">All Departments</li>
                        <li class="py-3 mx-3" data-filter=".Outpatient">Outpatient Surgery</li>
                        <li class="py-3 mx-3" data-filter=".Cardiac">Cardiac Clinic</li>
                        <li class="py-3 mx-3" data-filter=".Pediatric">Pediatric Clinic</li>
                        <li class="py-3 mx-3" data-filter=".Primary-Health">Primary Health Care</li>
                    </ul>
                </div>

                <div class="filters-content  wow fadeInUp" data-wow-duration="1.5s">
                    <div class="row grid portfolio-items">
                        <div class="col-md-6 col-12 all Cardiac">
                            <div class="item shadow text-center btn-gallery">
                                <img src="assets/images/portfolio/p-1.jpg" alt="Work 1" class="img-fluid">
                                <div class="magnific-icon">
                                    <a href="assets/images/portfolio/p-1.jpg" class="js-zoom-gallery"> <i class="mdi mdi-magnify-plus-outline text-white"></i> </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 all Outpatient">
                            <div class="item shadow text-center btn-gallery">
                                <img src="assets/images/portfolio/p-2.jpg" alt="Work 1" class="img-fluid">
                                <div class="magnific-icon">
                                    <a href="assets/images/portfolio/p-2.jpg" class="js-zoom-gallery"> <i class="mdi mdi-magnify-plus-outline text-white"></i> </a>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6 col-12 all Pediatric">
                            <div class="item shadow text-center btn-gallery">
                                <img src="assets/images/portfolio/p-3.jpg" alt="Work 1" class="img-fluid">
                                <div class="magnific-icon">
                                    <a href="assets/images/portfolio/p-3.jpg" class="js-zoom-gallery"> <i class="mdi mdi-magnify-plus-outline text-white"></i></a>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6 col-12 all Primary-Health">
                            <div class="item shadow text-center btn-gallery">
                                <img src="assets/images/portfolio/p-4.jpg" alt="Work 1" class="img-fluid">
                                <div class="magnific-icon">
                                    <a href="assets/images/portfolio/p-4.jpg" class="js-zoom-gallery"> <i class="mdi mdi-magnify-plus-outline text-white"></i> </a>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
        <!-- portfolio Grid-col-2 End -->
    </div>
</template>
<script>
    //ISOTOP JS
    import '../assets/js/jquery.isotope.min.js';
    //MAGNIFIC POPUP JS
    import 'magnific-popup/dist/jquery.magnific-popup.min.js';
    import 'magnific-popup/dist/magnific-popup.css';
    export default {
        name: "portfolioTwo",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.hidePreloader();
                this.istopGallery();
            },

            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            },
            istopGallery() {
                /*----MAGIC POPUP-----*/
                if (('.filters-content').length > 0) {
                    $('.filters-content').each(function () {
                        $(this).magnificPopup({
                            delegate: '.js-zoom-gallery',
                            type: 'image',
                            gallery: {
                                enabled: true
                            }
                        });
                    });
                }
                /*----ISOTOP JS-----*/
                var $container = $('.portfolio-items');
                $container.imagesLoaded(function () {
                    $container.isotope({
                        filter: '*',
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });
                });

                $('.portfolio-filter li').click(function () {
                    $('.portfolio-filter .current').removeClass('current');
                    $(this).addClass('current');
                    var selector = $(this).attr('data-filter');
                    $container.isotope({
                        filter: selector,
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });
                    return false;
                });
            }

        }
    }</script>
